import { Injectable, inject } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../../../auth/auth.service';
import { TimeBlockHttpService } from '../../../core/state/time-blocks/time-block-entries/time-block-http.service';
import { TimeBlockCrudService } from '../../../features/calendar/components/time-block/crud/time-block-crud.service';
import { TimeBlockContentType } from '../../../features/calendar/components/time-block/types/time-block-types';
import { TimeEntryConverter } from './converter/time-entry.converter';
import { TimeEntriesStore } from './state-and-data-handling/time-entries-data.store';
import { TimeBlockListEntry } from './time-enty-list-types';

@Injectable()
export class TimeEntriesListViewHttpService {
  // DI
  private readonly timeBlockHttpService = inject(TimeBlockHttpService);
  private readonly timeBlockCrudService = inject(TimeBlockCrudService);
  private readonly store = inject(TimeEntriesStore);
  private readonly authService = inject(AuthService);

  public loadTimeBlocks(): Observable<TimeBlockListEntry[]> {
    const start = new Date(2020, 1, 1); // Todo: Use correct start date.
    const end = new Date();
    const timeBlockContentTypes = [TimeBlockContentType.Project, TimeBlockContentType.Absence];
    const userId = this.authService.getLoggedInUserClone().id;

    const activeTimeBlocksObs$ = this.timeBlockHttpService.fetchActiveTimerTimeBlock(userId);

    const allTimeEntries = this.timeBlockCrudService
      .fetchTimeBlocks(start, end, [1], false, timeBlockContentTypes)
      .pipe(
        map((timeBlocks) => {
          return timeBlocks.map((timeBlock) => TimeEntryConverter.toTimeBlockListEntry(timeBlock));
        }),
      );

    return forkJoin([allTimeEntries, activeTimeBlocksObs$]).pipe(
      map(([timeEntries, activeTimerTimeEntry]) => {
        const allTimeEntries = [...timeEntries];
        if (activeTimerTimeEntry) {
          this.store.setActiveTimerTimeBlockEntry(activeTimerTimeEntry);
        }
        allTimeEntries.sort((first, second) => +second.from - +first.from);
        this.store.setTimeBlockEntries(allTimeEntries);
        return allTimeEntries;
      }),
    );
  }

  public deleteMultipleTimeBlocks(selectedIds: number[]): void {
    this.timeBlockHttpService.deleteMultipleBlocks(selectedIds);
  }
}
